import { render, staticRenderFns } from "./OrderRoundIncidents.vue?vue&type=template&id=bbf1092a&"
import script from "./OrderRoundIncidents.vue?vue&type=script&lang=js&"
export * from "./OrderRoundIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports